import { Record } from 'immutable';

module.exports = new Record({
  account: null,
  authenticatedPatientId: null,
  commonProducts: [],
  groups: [],
});



// WEBPACK FOOTER //
// ./main/records/session-state.js